import { createContext } from 'react';

import { SaveContextReturnType } from 'types/pages/audience-builder/shared/save/context';

export const SaveContext = createContext<SaveContextReturnType | null>(null);
